import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import { CommonSelectModal } from "@app/components/modals/CommonModal";
import { WidgetSelector } from "@app/components/WidgetStudio/WidgetSelector";
import { WidgetSettingsSchema } from "@app/pages/widget/Studio/widgetSettingsSchema";
import { WidgetStudio } from "@app/components/WidgetStudio";
import { MainContentContainer } from "@app/components/MainContainer";
import { MainHeader } from "@app/components/MainContainer/MainHeader";
import { MainContent } from "@app/components/MainContainer/MainContent";
import { MainTitle } from "@app/components/MainContainer/MainTitle";
import { MainDescription } from "@app/components/MainContainer/MainDescription";
import {Path} from "@app/route_path"
import { useModal } from "@shortsworks/ui";
import {
  useGetAccountAccessKey,
  useGetWidgets,
  useCreateWidget,
  useDeleteWidget,
  usePutWidget, useGetStoriesCount,
} from "@shortsworks/user-api"
import { useQueryClient } from "@tanstack/react-query";
import { LoaderCircle } from "lucide-react";
import {useState, useEffect} from "react"
import {useNavigate} from "react-router-dom"

export const Studio = () => {
  const { showModal } = useModal();
  const navigate = useNavigate();
  const {
    data: accountAccessKeyData,
    isSuccess: isSuccessGetAccountAccessKey,
  } = useGetAccountAccessKey();
  const [selectedWidgetId, setSelectedWidgetId] = useState<string>("");

  const queryClient = useQueryClient();
  const {data: storiesCountData, isSuccess: isSuccessGetStoriesCount} = useGetStoriesCount<{data: number}>({
    draft: false,
    hidden: false
  });

  // 포스팅이 없는 경우, 위젯이 표시되지 않는 점 알림 또는 스켈레톤 UI로 표시(pin-posting 이 있으므로 다른 페이지로 넘어갈 순 없음)
  // useEffect(() => {
  //   if(!isSuccessGetStoriesCount || storiesCountData.data === 0) {
  //     showModal(CommonErrorModal, {title: "포스팅이 없습니다. 포스팅을 먼저 올려주세요."});
  //     navigate(Path.POSTINGS);
  //   }
  // }, [isSuccessGetStoriesCount]);

  const {} = useCreateWidget();
  const {} = usePutWidget();
  const { data: widgetsData, queryKey: widgetsQueryKey } = useGetWidgets();
  const { mutateAsync: mutateAsyncDeleteWidget } = useDeleteWidget({
    mutation: {
      onSuccess: () => {
        return queryClient.invalidateQueries({ queryKey: widgetsQueryKey });
      },
      onError: () => {
        return showModal(CommonErrorModal, {
          title: "위젯 삭제하기를 실패했습니다.",
        });
      },
    },
  });

  const handleDeleteWidget = async () => {
    const modalResult = await showModal(CommonSelectModal, {
      title: "위젯을 삭제하시겠습니까?",
    }).promise();
    if (!modalResult.value) {
      return;
    }
    return mutateAsyncDeleteWidget({
      widgetId: encodeURIComponent(selectedWidgetId),
    });
  };

  const { form, schemas, zodSchema, parseForm } = useFormWithSchema({
    formSchemas: WidgetSettingsSchema,
    mode: "onChange",
  });

  if (!isSuccessGetAccountAccessKey) {
    return (
      <div className="flex w-full h-full items-center justify-center">
        <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />
      </div>
    );
  }

  return (
    <MainContentContainer>
      <MainHeader>
        <MainTitle>위젯 스튜디오</MainTitle>
        <MainDescription>위젯을 생성하거나 수정할 수 있습니다.</MainDescription>
      </MainHeader>
      <MainContent
        disableContainerScroll
        enableScrollInsideContainer
      >
        {/* selector 도 studio 안으로 이동 필요 */}
        <WidgetSelector
          selectedWidgetId={selectedWidgetId}
          onChangeSelectedWidgetId={setSelectedWidgetId}
        />
        <WidgetStudio
          accessKey={accountAccessKeyData.data.accessKey}
          selectedWidgetId={selectedWidgetId}
          onChangeSelectedWidgetId={selectedWidgetId}
          onDeleteWidget={handleDeleteWidget}
        />
      </MainContent>
    </MainContentContainer>
  );
};
